import React from "react";
import { CRITIZR } from "../../types/nps";
import Box from "../Box";
import {
  CIcon,
  CIconButton,
  CRating,
  CText,
} from "@carrefour/design-system-components-react";
import styled from "styled-components";
import CritizrIcon from "../icons/CritizrIcon";
import { Link } from "react-router-dom";
import Card from "../Card";
import BaseDashboardCard from "../BaseDashboardCard";

const BoxCustom = styled(Box)<{ gap: string }>`
  gap: ${(props) => props.gap};
  display: flex;
  align-items: center;
`;

const IconCustom = styled(CIcon)`
  position: "relative";
  font-size: 1.5rem;
`;

const Rating = styled(CRating)`
  & .c-rating__icon {
    font-size: 1.5rem;
  }
`;
const TextCustom = styled(CText)<{ $myColor: string }>`
  color: ${(props) => props?.$myColor} !important;
  padding: 8px;
  font-family: system-ui;
`;
const Text = styled(CText)`
  font-family: system-ui;
`;
type CritizrCardProps = {
  CritizrData: CRITIZR;
  isUnavailable: boolean;
  isLoading: boolean;
};

const MessagesIcon = ({ message }: { message: number }) => {
  return (
    <Box position={"relative"}>
      <IconCustom name={"messages"} data-testid={"critizr-icon"} />
      {message ? (
        <Box
          bg={"redMedium"}
          borderRadius={"50%"}
          height={3}
          maxWidth={4}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          position={"absolute"}
          top={"-50%"}
          left={"60%"}
        >
          <TextCustom bold $myColor="white" size={"s"}>
            {message}
          </TextCustom>
        </Box>
      ) : null}
    </Box>
  );
};

const CritizrCard = ({ CritizrData, ...res }: CritizrCardProps) => {
  return (
    <BaseDashboardCard
      hasModal={false}
      title={<CritizrIcon />}
      openInformationModal={() => null}
      size="small"
      {...res}
    >
      <Card>
        <BoxCustom
          display={"flex"}
          alignItems={"center"}
          py={0}
          justifyContent={"space-between"}
          gap={"1rem"}
        >
          <BoxCustom gap={"1rem"}>
            <Rating
              clickable={false}
              rate={
                !isNaN(CritizrData?.averageRating)
                  ? CritizrData?.averageRating
                  : 0
              }
            />
            <Text bold tagStyle={"p"}>{`${new Intl.NumberFormat("fr-FR", {
              maximumFractionDigits: 1,
              minimumFractionDigits: 0,
            }).format(CritizrData?.averageRating)}/5`}</Text>
          </BoxCustom>
          <BoxCustom gap={"14px"} display={"flex"} alignItems={"center"}>
            <MessagesIcon message={CritizrData?.messageCount} />
            <Link
              to={window?.config?.EXTERNAL_URLS?.CRITIZR}
              target="_blank"
              data-testid={"external-link"}
            >
              <CIconButton
                icon={"external-link"}
                variation={"tertiary"}
                tone={"main"}
                size={"m"}
              />
            </Link>
          </BoxCustom>
        </BoxCustom>
      </Card>
    </BaseDashboardCard>
  );
};

export default CritizrCard;
